import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-wenjian-2",
  "use": "icon-wenjian-2-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-wenjian-2\"><path d=\"M719.8 651.8m-10 0a10 10 0 1 0 20 0 10 10 0 1 0-20 0Z\" fill=\"#e6e6e6\" /><path d=\"M512.1 64H172v896h680V385.6L512.1 64z m278.8 324.3h-280v-265l280 265zM808 916H216V108h278.6l0.2 0.2v296.2h312.9l0.2 0.2V916z\" fill=\"#e6e6e6\" /><path d=\"M280.5 530h325.9v16H280.5z\" fill=\"#e6e6e6\" /><path d=\"M639.5 530h90.2v16h-90.2z\" fill=\"#e6e6e6\" /><path d=\"M403.5 641.8h277v16h-277z\" fill=\"#e6e6e6\" /><path d=\"M280.6 641.8h91.2v16h-91.2z\" fill=\"#e6e6e6\" /><path d=\"M279.9 753.7h326.5v16H279.9z\" fill=\"#e6e6e6\" /><path d=\"M655.8 753.7h73.9v16h-73.9z\" fill=\"#e6e6e6\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/wenjian-2.svg
// module id = BssJ
// module chunks = 77